import React from 'react'
import { useRecoilValue } from 'recoil'
import { Box, Text, CardDetails, CardRow } from '@/presentation/components'
import { serviceOrderDetailState } from '@/presentation/pages/ServiceOrderDetail/components'
import { styles } from '../../styles'

export const OsSignatures: React.FC = () => {
  const serviceOrderDetail = useRecoilValue(serviceOrderDetailState)

  return (
    <>
      {(serviceOrderDetail.encodeAssinatura || serviceOrderDetail.encodeAssinaturaTecnico) &&
        <>
          <Text style={styles.pageInfo}>Assinaturas</Text>
          <CardRow>
            <CardDetails>
              <Box style={styles.titleBox}>
                <Text style={styles.bold}>Assinatura Técnico</Text>
              </Box>
              <img src={`data:image/png;base64,${serviceOrderDetail.encodeAssinaturaTecnico}`} />
            </CardDetails>
            <CardDetails>
              <Box style={styles.titleBox}>
                <Text style={styles.bold}>Assinatura Cliente</Text>
              </Box>
              <img src={`data:image/png;base64,${serviceOrderDetail.encodeAssinatura}`} />
            </CardDetails>
          </CardRow>
        </>
      }
    </>
  )
}
